export const FONT_FAMILY = {
    poppins: 'font-family: Poppins;',
};

export const FONT_WEIGHT = {
    regular: 'font-weight: 400;',
    medium: 'font-weight: 500;',
    semibold: 'font-weight: 600;',
    bold: 'font-weight: 700;',
};

export const SIZES = {
    HEADING_XXXL: 'heading.xxxl',
    HEADING_XXL: 'heading.xxl',
    HEADING_XL: 'heading.xl',
    HEADING_LG: 'heading.lg',
    HEADING_MD: 'heading.md',
    HEADING_SM: 'heading.sm',
    HEADING_XS: 'heading.xs',
    HEADING_XXS: 'heading.xxs',
    HEADING_XXXS: 'heading.xxs',

    BODY_XL: 'body.xl',
    BODY_XL_MED: 'body.xl-med',
    BODY_XL_BOLD: 'body.xl-bold',
    BODY_XL_LINK: 'body.xl-link',

    BODY_LG: 'body.lg',
    BODY_LG_MED: 'body.lg-med',
    BODY_LG_BOLD: 'body.lg-bold',
    BODY_LG_LINK: 'body.lg-link',

    BODY_MD: 'body.md',
    BODY_MD_MED: 'body.md-med',
    BODY_MD_BOLD: 'body.md-bold',
    BODY_MD_LINK: 'body.md-link',

    BODY_SM: 'body.sm',
    BODY_SM_MED: 'body.sm-med',
    BODY_SM_BOLD: 'body.sm-bold',
    BODY_SM_LINK: 'body.sm-link',

    BODY_XS: 'body.xs',
    BODY_XS_MED: 'body.xs-med',
    BODY_XS_BOLD: 'body.xs-bold',
    BODY_XS_LINK: 'body.xs-link',
};

export const DESKTOP_SIZES = {
    [SIZES.HEADING_XXXL]: {
        fontSize: 'font-size: 64px;',
        lineHeight: 'line-height: 56px;',
        fontWeight: FONT_WEIGHT.semibold,
    },
    // Headings (Semibold)
    [SIZES.HEADING_XXL]: {
        fontSize: 'font-size: 48px;',
        lineHeight: 'line-height: 56px;',
        fontWeight: FONT_WEIGHT.semibold,
    },
    [SIZES.HEADING_XL]: {
        fontSize: 'font-size: 40px;',
        lineHeight: 'line-height: 48px;',
        fontWeight: FONT_WEIGHT.semibold,
    },
    [SIZES.HEADING_LG]: {
        fontSize: 'font-size: 32px;',
        lineHeight: 'line-height: 40px;',
        fontWeight: FONT_WEIGHT.semibold,
    },
    [SIZES.HEADING_MD]: {
        fontSize: 'font-size: 28px;',
        lineHeight: 'line-height: 36px;',
        fontWeight: FONT_WEIGHT.semibold,
    },
    [SIZES.HEADING_SM]: {
        fontSize: 'font-size: 24px;',
        lineHeight: 'line-height: 32px;',
        fontWeight: FONT_WEIGHT.semibold,
    },
    [SIZES.HEADING_XS]: {
        fontSize: 'font-size: 18px;',
        lineHeight: 'line-height: 24px;',
        fontWeight: FONT_WEIGHT.semibold,
    },
    [SIZES.HEADING_XXS]: {
        fontSize: 'font-size: 16px;',
        lineHeight: 'line-height: 24px;',
        fontWeight: FONT_WEIGHT.semibold,
    },
    [SIZES.HEADING_XXXS]: {
        fontSize: 'font-size: 14px;',
        lineHeight: 'line-height: 24px;',
        fontWeight: FONT_WEIGHT.semibold,
    },

    // Body
    [SIZES.BODY_XL]: {
        fontSize: 'font-size: 20px;',
        lineHeight: 'line-height: 28px;',
        fontWeight: FONT_WEIGHT.regular,
    },
    [SIZES.BODY_XL_MED]: {
        fontSize: 'font-size: 20px;',
        lineHeight: 'line-height: 28px;',
        fontWeight: FONT_WEIGHT.medium,
    },
    [SIZES.BODY_XL_BOLD]: {
        fontSize: 'font-size: 20px;',
        lineHeight: 'line-height: 28px;',
        fontWeight: FONT_WEIGHT.bold,
    },
    [SIZES.BODY_XL_LINK]: {
        fontSize: 'font-size: 20px;',
        lineHeight: 'line-height: 28px;',
        fontWeight: FONT_WEIGHT.regular,
        textDecoration: 'text-decoration: underline;',
    },

    [SIZES.BODY_LG]: {
        fontSize: 'font-size: 18px;',
        lineHeight: 'line-height: 28px;',
        fontWeight: FONT_WEIGHT.regular,
    },
    [SIZES.BODY_LG_MED]: {
        fontSize: 'font-size: 18px;',
        lineHeight: 'line-height: 28px;',
        fontWeight: FONT_WEIGHT.medium,
    },
    [SIZES.BODY_LG_BOLD]: {
        fontSize: 'font-size: 18px;',
        lineHeight: 'line-height: 28px;',
        fontWeight: FONT_WEIGHT.bold,
    },
    [SIZES.BODY_LG_LINK]: {
        fontSize: 'font-size: 18px;',
        lineHeight: 'line-height: 28px;',
        fontWeight: FONT_WEIGHT.regular,
        textDecoration: 'text-decoration: underline;',
    },

    [SIZES.BODY_MD]: {
        fontSize: 'font-size: 16px;',
        lineHeight: 'line-height: 24px;',
        fontWeight: FONT_WEIGHT.regular,
    },
    [SIZES.BODY_MD_MED]: {
        fontSize: 'font-size: 16px;',
        lineHeight: 'line-height: 24px;',
        fontWeight: FONT_WEIGHT.medium,
    },
    [SIZES.BODY_MD_BOLD]: {
        fontSize: 'font-size: 16px;',
        lineHeight: 'line-height: 24px;',
        fontWeight: FONT_WEIGHT.bold,
    },
    [SIZES.BODY_MD_LINK]: {
        fontSize: 'font-size: 16px;',
        lineHeight: 'line-height: 24px;',
        fontWeight: FONT_WEIGHT.regular,
        textDecoration: 'text-decoration: underline;',
    },

    [SIZES.BODY_SM]: {
        fontSize: 'font-size: 14px;',
        lineHeight: 'line-height: 20px;',
        fontWeight: FONT_WEIGHT.regular,
    },
    [SIZES.BODY_SM_MED]: {
        fontSize: 'font-size: 14px;',
        lineHeight: 'line-height: 20px;',
        fontWeight: FONT_WEIGHT.medium,
    },
    [SIZES.BODY_SM_BOLD]: {
        fontSize: 'font-size: 14px;',
        lineHeight: 'line-height: 20px;',
        fontWeight: FONT_WEIGHT.bold,
    },
    [SIZES.BODY_SM_LINK]: {
        fontSize: 'font-size: 14px;',
        lineHeight: 'line-height: 20px;',
        fontWeight: FONT_WEIGHT.regular,
        textDecoration: 'text-decoration: underline;',
    },

    [SIZES.BODY_XS]: {
        fontSize: 'font-size: 12px;',
        lineHeight: 'line-height: 16px;',
        fontWeight: FONT_WEIGHT.regular,
    },
    [SIZES.BODY_XS_MED]: {
        fontSize: 'font-size: 12px;',
        lineHeight: 'line-height: 16px;',
        fontWeight: FONT_WEIGHT.medium,
    },
    [SIZES.BODY_XS_BOLD]: {
        fontSize: 'font-size: 12px;',
        lineHeight: 'line-height: 16px;',
        fontWeight: FONT_WEIGHT.bold,
    },
    [SIZES.BODY_XS_LINK]: {
        fontSize: 'font-size: 12px;',
        lineHeight: 'line-height: 16px;',
        fontWeight: FONT_WEIGHT.regular,
        textDecoration: 'text-decoration: underline;',
    },
};
